"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MessageType = void 0;
var MessageType;
(function (MessageType) {
  MessageType["EMAIL"] = "EMAIL";
  MessageType["SMS"] = "SMS";
  MessageType["CHAT"] = "CHAT";
  MessageType["PHONE"] = "PHONE";
  MessageType["TWITTER"] = "TWITTER";
  // Only visible to Driftt users
  MessageType["PRIVATE_NOTE"] = "PRIVATE_NOTE";
  MessageType["CONVERSATION_EVENT"] = "CONVERSATION_EVENT";
  // campaign created
  MessageType["NPS_QUESTION"] = "NPS_QUESTION";
  MessageType["NPS_RESPONSE"] = "NPS_RESPONSE";
  MessageType["ANNOUNCEMENT"] = "ANNOUNCEMENT";
  MessageType["EMAIL_CAPTURE"] = "EMAIL_CAPTURE";
  MessageType["SUGGESTION"] = "SUGGESTION";
  MessageType["EDIT"] = "EDIT";
  MessageType["PRIVATE_PROMPT"] = "PRIVATE_PROMPT";
  MessageType["CHAT_RATING"] = "CHAT_RATING";
  MessageType["EMAIL_CAPTURE_CARD"] = "EMAIL_CAPTURE_CARD";
  MessageType["BOT_CONVERSATION_RATING"] = "BOT_CONVERSATION_RATING";
  MessageType["BOT_NODE_CONDITION_EVALUATION"] = "BOT_NODE_CONDITION_EVALUATION";
})(MessageType = exports.MessageType || (exports.MessageType = {}));